import type { SelectHTMLAttributes } from 'react';
import { forwardRef } from 'react';
import styles from './Input.module.css';

interface SelectProps extends SelectHTMLAttributes<HTMLSelectElement> {
  error?: boolean;
}

const Select = forwardRef<HTMLSelectElement, SelectProps>(
  ({ error, className, children, disabled, ...rest }, ref) => {
    const classes = [
      styles.select,
      error ? styles.error : '',
      className ?? '',
    ]
      .filter(Boolean)
      .join(' ');

    return (
      <select
        ref={ref}
        className={classes}
        disabled={disabled}
        aria-invalid={error || undefined}
        {...rest}
      >
        {children}
      </select>
    );
  }
);

Select.displayName = 'Select';

export default Select;
